import {useUser} from '@clerk/clerk-react';
import {Navigate, } from 'react-router-dom';
import React from "react";
import {CircularProgress} from "@mui/material";
import { CenteredElement } from '../components/CenteredElement';

export const ProtectedRoute = ({children}: { children: any }) => {
    const {isSignedIn, isLoaded} = useUser();

    if (!isLoaded) {
        return <CenteredElement><CircularProgress/></CenteredElement>
    }

    if (!isSignedIn) {
        return <Navigate to="/sign-in" replace/>;
    }

    return children;
};